module.exports = __webpack_public_path__ + "img/yeYaBeng4.ab593907.png";